import { VehicleQuestionModel } from '../../../../core/models/vehicle-question.model';
import { InsuranceDataEnum } from '../../../../core/consts/insurance-data.enum';
import { InsuranceDataStateService } from '../../../../core/services/impl/section-services/vehicle-data/insurance-data-state.service';
import { VehicleCondition } from '../../../../core/consts/vehicle-condition.enum';
import { Component, OnInit } from '@angular/core';

import { SectionBase } from '../../../components/section/section-base';
import { VehicleDataSectionConfig } from './vehicle-data-section.config';
import { VehicleDataStateService } from '../../../../core/services/impl/section-services/vehicle-data/vehicle-data-state.service';
import { VehicleDataEnum } from '../../../../core/consts/vehicle-data.enum';
import { Validators } from '@angular/forms';
import { VehicleStateStateService } from '../../../../core/services/impl/section-services/vehicle-data/vehicle-state-state.service';
import { VehicleStateEnum } from '../../../../core/consts/vehicle-state.enum';
import { PredefinedValuesService } from '../../../../core/services/impl/section-services/predefined-values/predefined-values.service';
import { PredefinedValuesStateService } from '../../../../core/services/impl/section-services/predefined-values/predefined-values-state.service';
import { DeviceService } from '../../../services/device.service';
import { VehicleModelConsts } from '../../../../core/consts/vehicle-model.consts';
import { VehicleModelStateService } from '../../../../core/services/impl/section-services/vehicle-model/vehicle-model-state.service';

@Component({
  selector: 'app-vehicle-data-section',
  templateUrl: './vehicle-data-section.component.html',
  styleUrls: ['./vehicle-data-section.component.scss']
})
export class VehicleDataSectionComponent extends SectionBase implements OnInit {

  public config: VehicleDataSectionConfig;
  public consts = {
    ...VehicleDataEnum,
    ...InsuranceDataEnum,
    ...VehicleStateEnum,
    ...VehicleModelConsts
  };
  public vehicleCondition = VehicleCondition;
  public dataPresentationFields: any[];

  get isVehicleDamaged(): boolean {
    return this.getControl(this.consts.VEHICLE_CONDITION).value === VehicleCondition.DAMAGED;
  }

  constructor(public vehicleDataStateService: VehicleDataStateService,
              private predefined: PredefinedValuesService,
              private predefinedState: PredefinedValuesStateService,
              private insuranceDataStateService: InsuranceDataStateService,
              private vehicleModelStateService: VehicleModelStateService,
              public vehicleStateStateService: VehicleStateStateService,
              public deviceService: DeviceService) {
    super();
    this.config = new VehicleDataSectionConfig(vehicleDataStateService, predefined, insuranceDataStateService, vehicleStateStateService);
  }

  ngOnInit() {
    this.initBean();
    this.initIsFieldDirtyBean();
    this.createConfig();
    this.buildForm();
    this.initControlsChanges();
    this.initFieldsWithDynamicValidators();
    this.prepareFieldsInPreviewMode();
  }

  initBean() {
    this.bean = {
      ...this.vehicleDataStateService.vehicleData,
      ...this.insuranceDataStateService.insuranceData,
      ...this.vehicleStateStateService.vehicleState,
    };
  }

  createConfig() {
    this.formConfig = this.config.createVehicleDataConfig();
  }

  initControlsChanges() {
    this.handleControlsState(
      {
        controlName: this.consts.FIRST_REGISTRATION_DATE,
        behaviour: value => this.vehicleDataStateService.changeFirstRegistrationDate(value)
      },
      {
        controlName: this.consts.ABROAD_IMPORTED,
        behaviour: value => this.vehicleStateStateService.changeAbroadImported(value)
      },
      {
        controlName: this.consts.VEHICLE_CONDITION, behaviour: value => {
          this.updateDamageDescriptionValidators(value);
          this.vehicleStateStateService.changeVehicleCondition(value);
        }
      },
      {
        controlName: this.consts.DAMAGE_DESCRIPTION,
        behaviour: value => this.vehicleStateStateService.changeDamageDescription(value)
      },
    );
  }

  markAsDirty(event) {
    this.predefinedState.isDirtyBean = event;
  }

  private initIsFieldDirtyBean() {
    this.isDirtyBean = this.predefinedState.isDirtyBean;
  }

  private initFieldsWithDynamicValidators(): void {
    const vehicleCondition = this.getControl(this.consts.VEHICLE_CONDITION).value;
    this.updateDamageDescriptionValidators(vehicleCondition);
  }

  private updateDamageDescriptionValidators(vehicleCondition: VehicleCondition): void {
    if (vehicleCondition === VehicleCondition.DAMAGED) {
      this.getControl(this.consts.DAMAGE_DESCRIPTION).setValidators([Validators.required, Validators.maxLength(1000)]);
    } else {
      this.getControl(this.consts.DAMAGE_DESCRIPTION).reset();
      this.getControl(this.consts.DAMAGE_DESCRIPTION).clearValidators();
    }
    this.getControl(this.consts.DAMAGE_DESCRIPTION).updateValueAndValidity();
  }

  private prepareFieldsInPreviewMode(): void {
    this.dataPresentationFields = [
        this.consts.VEHICLE_CONDITION,
        this.consts.FIRST_REGISTRATION_DATE,
        this.consts.ABROAD_IMPORTED,
        this.consts.REGISTRATION_NUMBER
    ];

    if (this.isVehicleDamaged) {
      this.dataPresentationFields.push(this.consts.DAMAGE_DESCRIPTION);
    }
  }
}
